import { Redirect, useParams } from 'react-router-dom';

// Old /client-accounts-list/details/:AccountID links (bookmarks, emails) forward to the current detail page.
export default function LegacyClientAccountRedirect() {
  const { AccountID } = useParams<{ AccountID: string }>();

  return <Redirect to={`/client-accounts/${AccountID}`} />;
}
